import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { REQUIRE_AUTH } from '../../shared/interceptors/auth-context';

export interface CreateUserWithRoleRequest {
  FirstName: string;
  LastName: string;
  Email: string;
  Phone?: string | null;
  Password: string;
  RoleId: string;
  BusinessId: string;
  CountryId: string;
}

export interface CreateUserWithRoleResponse {
  userId: string;
  message: string;
}

export interface UserProfileDto {
  userId: string;
  firstName: string;
  lastName: string;
  email: string;
  phone?: string | null;
  countryId: string;
  businessTypeId?: string | null;
  businessId?: string | null;
  businessName?: string | null;
  businessDescription?: string | null;
  businessLogoUrl?: string | null;
  publicSlug?: string | null;
  primaryColor?: string | null;
  secondaryColor?: string | null;
  address?: string | null;
  businessPhone?: string | null;
  businessWhatsApp?: string | null;
  isGoogleLinked: boolean;
}

export interface UpdateUserProfileRequest {
  firstName: string;
  lastName: string;
  email: string;
  phone?: string | null;
  countryId: string;
  businessTypeId?: string | null;
  password?: string | null;
}

@Injectable({ providedIn: 'root' })
export class UsersService {
  private http = inject(HttpClient);
  private baseUrl = environment.apiUrl;

  createWithRole(
    req: CreateUserWithRoleRequest
  ): Observable<CreateUserWithRoleResponse> {
    return this.http.post<CreateUserWithRoleResponse>(
      `${this.baseUrl}/api/v1/users/with-role`,
      req,
      {
        context: new HttpContext().set(REQUIRE_AUTH, true),
      }
    );
  }

  getProfile(): Observable<UserProfileDto> {
    return this.http.get<UserProfileDto>(`${this.baseUrl}/api/v1/users/me`, {
      context: new HttpContext().set(REQUIRE_AUTH, true),
    });
  }

  updateProfile(payload: UpdateUserProfileRequest): Observable<UserProfileDto> {
    return this.http.put<UserProfileDto>(
      `${this.baseUrl}/api/v1/users/me`,
      payload,
      {
        context: new HttpContext().set(REQUIRE_AUTH, true),
      }
    );
  }
}
